module.exports = __webpack_public_path__ + "img/list0.cee6951f.jpg";